if (!window.customElements.get("copy-to-clipboard")) {
  class CopyToClipboard extends HTMLElement {
    constructor() {
      super();

      this.isCopied = false;
      this.copyIcon = window.theme.icons.copy;
      this.checkmarkIcon = window.theme.icons.checkmark;
    }

    get copyText() {
      return this.getAttribute("data-copy") || "Copy";
    }

    get copiedText() {
      return this.getAttribute("data-copied") || "Copied!";
    }

    get referralLink() {
      return this.getAttribute("data-text");
    }

    connectedCallback() {
      if (!this.referralLink) return;

      // Create button element
      const button = document.createElement("button");
      button.className = "Button Button--secondary Button--full";
      this.appendChild(button);
      this.button = button;

      // Set initial content
      this.updateButtonContent(this.copyText, this.copyIcon);

      // Add click event listener to the entire element
      this.addEventListener("click", this.handleCopy.bind(this));
    }

    handleCopy() {
      const textToCopy = this.referralLink;

      // Create temporary textarea element
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);

      // Select and copy text
      textarea.select();
      textarea.setSelectionRange(0, 99999); // For mobile devices
      navigator.clipboard.writeText(textToCopy);
      document.body.removeChild(textarea);

      // Update state and UI
      this.isCopied = true;
      this.updateButtonContent(this.copiedText, this.checkmarkIcon);

      // Reset after 3 seconds
      setTimeout(() => {
        this.isCopied = false;
        this.updateButtonContent(this.copyText, this.copyIcon);
      }, 4000);
    }

    updateButtonContent(text, icon) {
      this.isCopied
        ? this.button.classList.add("active")
        : this.button.classList.remove("active");
      this.button.innerHTML = `${icon}${text}`;
    }
  }

  customElements.define("copy-to-clipboard", CopyToClipboard);
}
